function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * インタラクション　モデル
 */
var InteractionInstanceModel =
/**
 * コンストラクタ
 *
 * @param no 番号
 */
function InteractionInstanceModel(no) {
  _classCallCheck(this, InteractionInstanceModel);

  this.No = no;
  this.Triggers = [];
  this.Actions = [];
  this.hasChange = false;
};

export { InteractionInstanceModel as default };